// eslint-disable max-len
import {BrowserModule, provideClientHydration} from '@angular/platform-browser'
import {APP_ID, NgModule} from '@angular/core'
import {AppRoutingModule} from './app-routing.module'
import {AppComponent} from './app.component'
import {HttpClientJsonpModule, HttpClientModule} from '@angular/common/http'
import {ApolloModule} from 'apollo-angular'
import {CommonModule, registerLocaleData} from '@angular/common'
import {TranslocoService} from '@ngneat/transloco'
import {provideApolloOptions} from './core/graphql/apollo-factory'
import {ReactiveFormsModule} from '@angular/forms'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {TranslocoRootModule} from './core/i18n/transloco-root.module'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {DialogModule} from './craft/dialog/dialog.module'
import {I18nService} from './craft/i18n/i18n.service'
import {provideImageApiLoader} from './core/picture/loaders/loader'
import {TraceService} from '@sentry/angular-ivy'
import {RouterModule} from '@angular/router'
import {ToastModule} from './shared/components/toast/toast.module'
import {LoadingProgressComponent} from './core/components/loading/loading-progress.component'
import {LayoutComponent} from './core/components/layout/layout.component'
import {provideHttpInterceptors} from './core/http/providers'
import {provideLocaleId} from './core/i18n/providers'
import {provideErrorHandler, provideTracing} from './core/error/providers'
import {AnalyticsComponent} from './core/analytics/analytics.component'
import localeDeCH from '@angular/common/locales/de-CH'
import localeFrCH from '@angular/common/locales/fr-CH'
import localeItCH from '@angular/common/locales/it-CH'

registerLocaleData(localeDeCH)
registerLocaleData(localeFrCH)
registerLocaleData(localeItCH)

// eslint-enable max-len

@NgModule({
  bootstrap: [AppComponent],
  declarations: [AppComponent, LoadingProgressComponent],
  imports: [
    CommonModule,
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    TranslocoRootModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    ApolloModule,
    HttpClientModule,
    HttpClientJsonpModule,
    ToastModule,
    DialogModule,
    LayoutComponent,
    AnalyticsComponent,
  ],
  providers: [
    {provide: APP_ID, useValue: 'bgo-ui'},
    provideClientHydration(),
    provideLocaleId(),
    provideErrorHandler(),
    provideImageApiLoader(),
    provideTracing(),
    provideApolloOptions(),
    provideHttpInterceptors(),
  ],
})
export class AppModule {
  constructor(
    private i18n: I18nService,
    translocoService: TranslocoService,
    trace: TraceService, // initialize trace service by injecting it
  ) {
    this.i18n.override(translocoService)
  }
}
